'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useServicePurchaseActions, useServicePurchaseState } from '@/modules/service-purchase/providers/service-purchase-store-provider';
import { FacetSelect } from './facet-select';
function FacetSelectionSection() {
  const $ = _c(9);
  const {
    facets
  } = useServicePurchaseState();
  const {
    selectedFacetOption
  } = useServicePurchaseActions();
  let t0;
  if ($[0] !== facets) {
    t0 = facets.filter(_temp);
    $[0] = facets;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const visibleFacets = t0;
  if (visibleFacets.length === 0) {
    return null;
  }
  let t1;
  if ($[2] !== selectedFacetOption || $[3] !== visibleFacets) {
    let t2;
    if ($[5] !== selectedFacetOption) {
      t2 = facet_0 => <FacetSelect key={facet_0.originalFacet.categoryKey} categoryLabel={facet_0.originalFacet.categoryLabel} value={facet_0.selectedOption} onValueChange={value => {
        selectedFacetOption(facet_0.originalFacet.categoryKey, value);
      }} options={facet_0.originalFacet.selectedOptions} />;
      $[5] = selectedFacetOption;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = visibleFacets.map(t2);
    $[2] = selectedFacetOption;
    $[3] = visibleFacets;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="grid w-full grid-cols-1 gap-6 lg:grid-cols-4">{t1}</div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp(facet) {
  return facet.originalFacet.selectedOptions.length > 1;
}
export { FacetSelectionSection };